export function pretty(value: object) {
    try {
        return JSON.stringify(value, null, 2);
    } catch (e) {
        return value;
    }
}